module.exports = __webpack_public_path__ + "img/reaktif.36e26244.svg";